export function isUniqueIdRequired(country) {
  const uniqueIdCountries = ['BR', 'CL', 'CN', 'CO', 'KR', 'IL', 'PE', 'UY']

  return uniqueIdCountries.includes(country)
}
